import { NavLink } from 'react-router-dom';

import '../styles/side-nav.css';

export default function SideNav({ items, badges }) {
    return (
        <nav className="side-nav" aria-label="Principal">
            <div className="side-nav__brand">
                <span className="side-nav__mark" aria-hidden="true">M</span>
                <span className="side-nav__name">
                    Mastermind
                    <span className="side-nav__subtitle">Borrador móvil</span>
                </span>
            </div>
            <ul className="side-nav__list">
                {items.map(({ key, label, path, Icon }) => (
                    <li key={key}>
                        <NavLink
                            to={path}
                            className={({ isActive }) => `side-nav__link${isActive ? ' side-nav__link--active' : ''}`}
                        >
                            <Icon size={20} />
                            <span className="side-nav__label">{label}</span>
                            {badges[key] > 0 && (
                                <span className="side-nav__badge">
                                    {badges[key]}
                                    <span className="visually-hidden"> pendientes</span>
                                </span>
                            )}
                        </NavLink>
                    </li>
                ))}
            </ul>
            <p className="side-nav__footnote">
                Prototipo navegable. No inicia sesión en Mastermind ni ejecuta acciones reales.
            </p>
        </nav>
    );
}
